import { render, staticRenderFns } from "./HelpBtn.vue?vue&type=template&id=78418f53&scoped=true&"
import script from "./HelpBtn.vue?vue&type=script&lang=js&"
export * from "./HelpBtn.vue?vue&type=script&lang=js&"
import style0 from "./HelpBtn.vue?vue&type=style&index=0&id=78418f53&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78418f53",
  null
  
)

export default component.exports